/**
 * Day 別セクション定義（PoC frontend/src/section-classifier/data/sampleTranscript.ts より）
 *
 * 火曜MVP では Day1 のみ正式対応。Day2-Day4 は現状 Day1 と同じ定義を返す
 * （将来的に各 Day の正規セクションに差し替え予定）。
 */

import type { SectionDefinition } from './types';

export const DAY1_SECTIONS: SectionDefinition[] = [
  { id: 'promise',          name: 'お約束',          bgColor: 'bg-blue-50',   borderColor: 'border-l-blue-400',   textColor: 'text-blue-700',   order: 1 },
  { id: 'expectation',      name: '期待',            bgColor: 'bg-green-50',  borderColor: 'border-l-green-400',  textColor: 'text-green-700',  order: 2 },
  { id: 'achievement',      name: '達成',            bgColor: 'bg-yellow-50', borderColor: 'border-l-yellow-500', textColor: 'text-yellow-700', order: 3 },
  { id: 'problem',          name: '問題・懸念',       bgColor: 'bg-red-50',    borderColor: 'border-l-red-400',    textColor: 'text-red-700',    order: 4 },
  { id: 'strategic_focus',  name: '戦略的フォーカス',  bgColor: 'bg-purple-50', borderColor: 'border-l-purple-400', textColor: 'text-purple-700', order: 5 },
  { id: 'baumkuchen',       name: 'バームクーヘン',    bgColor: 'bg-orange-50', borderColor: 'border-l-orange-400', textColor: 'text-orange-700', order: 6 },
  { id: 'commitment',       name: 'コミットメント',    bgColor: 'bg-teal-50',   borderColor: 'border-l-teal-400',   textColor: 'text-teal-700',   order: 7 },
];

export function getSectionsForDay(_day?: string | null): SectionDefinition[] {
  // 現状 Day2-Day4 も Day1 を流用（仕様確定後に差し替え）
  return DAY1_SECTIONS;
}
